export const SUPPORT_CHAT_MODULE = 'SUPPORT_CHAT_MODULE';
export const SUPPORT_CHAT_INTERFACE = 'SUPPORT_CHAT_INTERFACE';

export const RESERVE_CDN_FILE_PATH = 'active/index.js';

export const RESERVE_URLS: { [key: string]: string } = {
  'https://support-backend.usrsprt-rc.xyz': 'https://cdn.usrsprt-rc.xyz/builds',
  'https://support-backend.usrsprt.com': 'https://cdn.usrsprt.com/builds',
};

export const DEV_LINK = 'https://cdn.usrsprt.xyz/builds';
